module.exports = __webpack_public_path__ + "static/media/support.c56bcf46.svg";